import create from "zustand";
import { DEFAULT_MATCH_POINTS } from "../matches/match.schema";
export interface AddMatchFormValues {
  a: string;
  b: string;
  // won: string;
  addMore: boolean;
  aPoints: number;
  bPoints: number;
  // showPoints: boolean;
}
export const DEFAULT_MATCH_FORM_VALUES = {
  a: "",
  b: "",
  // won: "won",
  addMore: false,
  aPoints: DEFAULT_MATCH_POINTS,
  bPoints: 0,
  // showPoints: false,
};
export interface MatchState {
  formValues?: AddMatchFormValues | null;
  // eslint-disable-next-line unused-imports/no-unused-vars
  setFormValues: (values: AddMatchFormValues) => void;
  resetFormValues: () => void;
}
export const useMatchStore = create<MatchState>((set) => ({
  setFormValues: (formValues: AddMatchFormValues) =>
    set(() => ({ formValues })),
  resetFormValues: () => {
    set(() => ({ formValues: null }));
  },
}));
